import { LOGIN_LOGO_URL } from "constants/brand";

let preloadPromise = null;
let isPreloaded = false;

export const getLoginLogoPreloadStatus = () => isPreloaded;

export const preloadLoginLogo = () => {
  if (isPreloaded) {
    return Promise.resolve();
  }

  if (!preloadPromise) {
    preloadPromise = new Promise((resolve, reject) => {
      const img = new Image();
      img.decoding = "async";
      img.onload = () => {
        isPreloaded = true;
        resolve();
      };
      img.onerror = reject;
      img.src = LOGIN_LOGO_URL;
    });
  }

  return preloadPromise;
};
